// 顧客が負担するUber配達手数料（CalcGoukei.jsx から分けた・2026-11-04）。
// 画面の部品を読み込まずにテストできるよう、計算と文言だけをここに置く。
const UBER_FEE_FALLBACK = 490;

export const uberFee = (data) => {
  // 「自分で預ける(own)」は常に0円。quoteは配達(uber)前提で取得したまま切替時に
  // 再取得しないため、サーバ値を優先すると own でも配達代が合計に乗ってしまう
  // （2026-09-01 表示バグ修正。実請求はサーバが user_dropoff_type で正しく計算している）。
  // ロッカー受取に有料(locker_fee>0)を導入する場合は quote の再取得が必要。
  if (data?.user_dropoff_type === 'own') return 0;
  const v = Number(data?.quote?.uber_fee);
  if (Number.isFinite(v)) return v;
  // 旧API互換: 無料条件をアプリ側で再現する
  if (data?.item?.is_syokai === '1' || data?.item?.id === '0') return 0;
  return UBER_FEE_FALLBACK;
};

// 「通常◯円」として見せる定価。無料訴求（→初回無料！）の元の金額にも使う。
export const uberFeeNormal = (data) => {
  const v = Number(data?.quote?.uber_fee_normal);
  if (Number.isFinite(v) && v > 0) return v;
  const q = Number(data?.quote?.fee);
  return Number.isFinite(q) && q > 0 ? q : UBER_FEE_FALLBACK;
};


// 確認画面の配達手数料の見出し。通常より安いときだけ「今なら通常◯円→」を付ける
// （2026-11-04 坂元さん: 割引が無いのに「今なら往復通常490円→490円」と出ていた。10/1 の改定後は 990円→990円 と並んでいた）。
// discounted のときは、このあとに赤字の金額と「）」を続けて出す。
export const uberFeeCaption = (data) => {
  const roundTrip = data?.item?.type !== 'futon_bag';
  const normal = uberFeeNormal(data);
  const discounted = normal > uberFee(data);
  if (!discounted) return { discounted, text: roundTrip ? 'Uber配達手数料（往復分）' : 'Uber配達手数料' };
  return { discounted, text: `Uber配達手数料（今なら${roundTrip ? '往復分' : ''}通常${normal.toLocaleString()}円→` };
};
